import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import './SitePlans.css';
import AssetsManager from '../assets_management/AssetsManager';
import SitePlan from './SitePlan';
import GenericWindow from '../window/GenericWindow';
import Windows from '../window/Windows';
import WindowType from '../enums/WindowType';
import WindowEventNames from '../window/WindowEventNames';
export default class SitePlanWrapper {
	constructor({configuration, parentElement, hasFilteredOptions, siteJsons}){
		this._configuration = configuration;
		this._hasFilteredOptions = hasFilteredOptions;
		this._siteJsons = siteJsons;
		this.initialize = this.initialize.bind(this);
		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
		this.fillLeftHalf = this.fillLeftHalf.bind(this);
		this.fillRightHalf = this.fillRightHalf.bind(this);
		const title = this._configuration.siteName;
		this._window = new GenericWindow({tooltipMessage:title, name:title, 
			minWidth:100, maxWidth:1700, minHeight:100, maxHeight:1000,
			defaultWidth:600, defaultHeight:600, defaultX:10, defaultY:10, minimized:!hasFilteredOptions, 
			maximized:false, minimizable:true, maximizable:true, closeable:true,
			minimizeOnClose:true, resizable:!window.isMobile, dragable:true, type:WindowType.SITE_PLAN,
			parentElement
	  });
		this._element = this._window.getElement();
		this._element.classList.add('site-plan-wrapper');
	}
	
	get element(){
		return this._element;
	}
	get hasFilteredOptions(){
		return this._hasFilteredOptions;
	}
	fillLeftHalf(){
		this._window.fillLeftHalf();
	}
	fillRightHalf(){
		this._window.fillRightHalf();
	}
	show(maximised){
		if(!maximised)
			this._window.unminimize();
		else this._window.maximize();
		this._window.bringToFront();
	}
	hide(){
		this._window.minimize();
	}
	get sitePlan(){
		return this._sitePlan;
	}
	get siteName(){
		return this._configuration.siteName;
	}
	initialize(){
		return new Promise((resolve, reject)=>{
			const sitePlanFactory = React.createFactory(SitePlan);
			ReactDOM.render(sitePlanFactory({ 
				ref:React.createRef(),
				configuration:this._configuration,
				callbackDidMount:(sitePlan)=>{
					this._sitePlan = sitePlan;
					setTimeout(()=>{
						sitePlan.initialize({siteJsons:this._siteJsons}).then(()=>{
							resolve(sitePlan);
						}).catch(reject);
					},0);
					this._window.addEventListener(WindowEventNames.MAXIMIZED, this._sitePlan.resize);
					this._window.addEventListener(WindowEventNames.MINIMIZED, this._sitePlan.resize);
				}
			}),
			this._window.getMainElement());
		});
	}
}
